import { ExtendBorrowCheckComponent } from "../../../components/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowCheckComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function ExtendBorrowCheckContainer() {
  const titleName =
    "รายละเอียดการแจ้งเลื่อนหลักสูตรการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ExtendBorrowCheckComponent />
      <Footer />
    </div>
  );
}
